export const actionRewardsHeaders = [
  {
    key: 'actions',
    value: 'Actions',
  },
  {
    key: 'application',
    value: 'Application',
  },
  {
    key: 'campaignID',
    value: 'Campaign ID',
  },
  {
    key: 'actionReward',
    value: 'Action Reward',
  },
  {
    key: 'bonusAmount',
    value: 'Bonus Amount',
  },
  {
    key: 'config',
    value: 'Config',
  },
  {
    key: 'startDate',
    value: 'Start Date',
  },
  {
    key: 'endDate',
    value: 'End Date',
  },
  {
    key: 'modifiedAuthor',
    value: 'Modified Author',
  },
];

export const campaignTypes = [
  {
    label: 'New Enrollment',
    value: 'NEW_ENROLLMENT',
  },
  {
    label: 'Anytime Enrollment',
    value: 'ANYTIME_ENROLLMENT',
  },
  {
    label: 'Abandoned Enrollment',
    value: 'ABANDONED_ENROLLMENT',
  },
  {
    label: 'Multi Extension Enrollment',
    value: 'MULTI_EXTENSION_ENROLLMENT',
  },
  {
    label: 'First Commission',
    value: 'FIRST_COMMISSION',
  },
  {
    label: 'Segment Commission',
    value: 'SEGMENT_COMMISSION',
  },
  {
    label: 'UUID First Commission',
    value: 'UUID_FIRST_COMMISSION',
  },
  {
    label: 'Anytime First Commission',
    value: 'ANYTIME_FIRST_COMMISSION',
  },
  {
    label: 'Dormant Purchaser',
    value: 'DORMANT_PURCHASER',
  },
];

export const actionRewardDescriptions: Record<string, string> = {
  NEW_ENROLLMENT: 'Rewards users who sign up and complete enrollment during the campaign period',
  ANYTIME_ENROLLMENT:
    'Rewards users who complete enrollment during the campaign period, regardless of when they started signup',
  ABANDONED_ENROLLMENT:
    'Rewards users who previously started but abandoned signup, then returned and completed enrollment during the campaign',
  MULTI_EXTENSION_ENROLLMENT:
    'Rewards users who enroll in a specific application during a defined enrollment window, then install the target application during the campaign period within the allowed number of days',
  FIRST_COMMISSION:
    'Rewards new users for their first-ever qualifying purchase during the campaign. The purchase must occur within the specified number of days from enrollment',
  SEGMENT_COMMISSION:
    'Segment commission bonus',
  UUID_FIRST_COMMISSION:
    'Rewards new users for their first-ever qualifying purchase during the campaign, identified by a specific campaign code. The purchase must occur within the specified number of days from enrollment',
  ANYTIME_FIRST_COMMISSION:
    'Rewards users for their first-ever qualifying purchase during an active campaign period, regardless of when they enrolled. Applies to both new and existing users',
  DORMANT_PURCHASER:
    'Rewards users who have not made a qualifying purchase in at least the specified number of days and then make a purchase during the campaign period',
};
